module.exports = __webpack_public_path__ + "static/pizza27-3f8611404049ea830a17fd71fa638d10.webp";